import { INetworkStateFreeGame } from "@spawn/freegames";
import { HasNudgingNetworkState } from "@spawn/nudge";
import { HasRevealNetworkState } from "@spawn/reveal";

export type IGameNetworkState = HasRevealNetworkState &
	HasNudgingNetworkState &
	INetworkStateFreeGame &
	INrgFeatureState & {
		/**
		 * Holds the reels shown before the resumed spin starts
		 */
		initialResumeReels?: string[][];
		/**
		 * Base-game triggering data used to restore reels/reveal/nudging after freegames.
		 */
		fgTriggerState?: IFGTriggerState;
	};

export type INrgFeatureState = {
	/**
	 * Holds the reels before the nudge-up animation(s)
	 * (should have more than 6 symbols/reel depending on the number of extra scatters)
	 * ex for 2 scatters and mystery symbols on reels 2 and 4: [
	 *  [1, 2, 3, 4, 5, 6],
	 *  [1, 2, 3, 4, 5, 6, 7, 8],
	 *  [1, 2, 3, 4, 5, 6],
	 *  [1, 2, 3, 4, 5, 6, 7, 8],
	 *  [1, 2, 3, 4, 5, 6]
	 */
	preNudgeUpReels?: string[][];
};

export type IFGTriggerState = {
	reels: string[][];
	reveal: HasRevealNetworkState["reveal"];
	nudging: HasNudgingNetworkState["nudging"];
};
